import { CalendarCheck, UserCheck, Flag, CreditCard, LineChart } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const steps = [
  { icon: CalendarCheck, title: "Réservation", desc: "La demande arrive, la formule et les participants sont enregistrés." },
  { icon: UserCheck, title: "Check-in", desc: "Le client est accueilli, l'équipe et le matériel sont affectés." },
  { icon: Flag, title: "Activité", desc: "Le départ est suivi, la flotte et les guides restent visibles." },
  { icon: CreditCard, title: "Paiement", desc: "L'encaissement est enregistré en caisse, relié à la réservation." },
  { icon: LineChart, title: "Suivi opérationnel", desc: "Dépenses, incidents et résultats alimentent vos statistiques." },
];

const Operations = () => (
  <section data-testid="operations-section" className="bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow index="04">Opérations</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Du bureau au terrain.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          ActiPilote suit votre exploitation quotidienne, de la première demande jusqu'au résultat.
        </p>
      </Reveal>

      <div className="relative mt-14">
        <div className="absolute left-0 right-0 top-6 hidden h-px bg-slate-200 lg:block" aria-hidden="true" />
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={0.08 * i}>
              <div data-testid={`operation-step-${i + 1}`} className="relative">
                <div className="flex items-center gap-3">
                  <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white text-brand shadow-soft">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-xs font-bold text-navy/30">0{i + 1}</span>
                </div>
                <h3 className="mt-4 text-base font-bold text-navy">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-navy/60">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Operations;
